import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ReajectReason(props) {
  
  return (
    <React.Fragment>
      
      <Dialog
        open={props.open}
        onClose={props.handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (e) => {   
            e.preventDefault();        
            props.handleReject;
          },
        }}
      >
        <DialogTitle>Reject</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{width:'30vw'}}>
            Give a reason for rejection
          </DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="name"
            name="reason"
            label="Reason"
            type="text"
            fullWidth
            variant="standard"
            onChange={(e)=>props.setRejectReason(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Cancel</Button>
          <Button onClick={props.handleReject}>Reject</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}